import { z } from 'zod';
import { meta } from '../meta';

export const AudioPropsSchema = z.object({
  src: z.string().default('').meta(meta({ label: '音频', setter: 'audio' })),
  autoplay: z.boolean().default(true).meta(meta({ label: '自动播放', setter: 'switch' })),
  loop: z.boolean().default(true).meta(meta({ label: '循环', setter: 'switch' })),
  iconColor: z.string().default('#ffffff').meta(meta({ label: '图标色', setter: 'color', group: '样式' })),
  bgColor: z.string().default('rgba(0,0,0,0.45)').meta(meta({ label: '底色', setter: 'color', group: '样式' })),
});

export type AudioProps = z.infer<typeof AudioPropsSchema>;
